import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header header-sticky mb-4" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "mx-4 d-md-none" }
const _hoisted_4 = {
  class: "header-nav",
  role: "navigation"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "header-divider" }, null, -1)
const _hoisted_6 = { class: "container-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BIconList = _resolveComponent("BIconList")!
  const _component_inlineSvg = _resolveComponent("inlineSvg")!
  const _component_AppAccount = _resolveComponent("AppAccount")!
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "header-toggler px-md-0 me-md-3",
        type: "button",
        "aria-label": "Toggle navigation",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.commit('theme/toggleSidebar')))
      }, [
        _createVNode(_component_BIconList, {
          width: "1.1em",
          height: "1.1em"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_inlineSvg, {
          src: require('@/assets/brand/logo-slub-symboliczny.svg'),
          height: "45"
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AppAccount)
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_AppBreadcrumb)
    ])
  ]))
}